
import HomePage from '../pages/home.vue';
import AboutPage from '../pages/about.vue';
import FormPage from '../pages/form.vue';
import CatalogPage from '../pages/catalog.vue';
import ProductPage from '../pages/product.vue';
import SettingsPage from '../pages/settings.vue';

import DynamicRoutePage from '../pages/dynamic-route.vue';
import RequestAndLoad from '../pages/request-and-load.vue';
import NotFoundPage from '../pages/404.vue';

//Viet
import LoginPage from '../pages/login.vue';
import ListQuizPage from '../pages/list-quiz.vue';
import UserQuizPage from '../pages/user-quiz.vue';
import ResultQuizPage from '../pages/result-quiz.vue';
import ResultDetailQuizPage from '../pages/result-detail-quiz.vue';
import ProfilePage from '../pages/profile.vue';
import MyUserQuizPage from '../pages/my-user-quiz.vue';

var routes = [
  {
    path: '/',
    component: LoginPage,
    // component: HomePage,
  },
  {
    path: '/list-quiz/',
    component: ListQuizPage,
  },
  {
    path: '/profile/:userId',
    component: ProfilePage,
  },
  {
    path: '/result-quiz/:userquizId',
    component: ResultQuizPage,
  },
  {
    path: '/my-user-quiz/:userId',
    component: MyUserQuizPage,
  },
  {
    path: '/result-detail-quiz/:userquizId',
    component: ResultDetailQuizPage,
  },
  {
    path: '/user-quiz/:quizId/:totalTime/',
    component: UserQuizPage
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/product/:id/',
    component: ProductPage,
  },
  {
    path: '/settings/',
    component: SettingsPage,
  },

  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
